import React from 'react'
import {Link} from "react-router-dom";

import "./Navbar.css";

function Navbar() {
  return (
    <div>
        <div className="fixed-top">
       
  <div className="besttiles">
          <div className="album py-1">

            <div className="container">

              <div className="row ">

                <div className="col-md-5">
                  <div className="d-flex justify-content-between align-items-center">


                    <a style={{color:"white"}} href='tel:  9932338173'> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-minus" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                    </svg> +91  99323 38173</a>
                   <a style={{color:"white"}} href='https://share.google/xQcpg4Tz8e51mfphp' target="_blank" rel="noopener noreferrer" ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-merge-right-fill" viewBox="0 0 16 16">
  <path d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zM8.75 6v1q.211.451.588.95c.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41z"/>
</svg> Direction</a>
                  </div>

                </div>

                <div className="d-flex justify-content-between align-items-center">


                </div>
              </div>
            </div>
          </div>
        </div>
      <nav className="navbar navbar-expand-lg navbar-white bg-white shadow">
  <div className="container-fluid">
    <Link to="/" style={{color:"#0010AE"}} className="navbar-brand"> <b>UMA HARDWARE</b></Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a href='/' style={{color:"#050f67ff"}} className="nav-link active" aria-current="page">Home</a>
        </li>
        <li className="nav-item">
          <a href='Kajaria'  className="nav-link" style={{color:"#050f67ff"}}  >Kajaria</a>
        </li>
        <li className="nav-item">
          <a href='Johnson' style={{color:"#050f67ff"}} className="nav-link" >Johnson</a>
        </li>
        <li className="nav-item">
          <a href='Orientbell' style={{color:"#050f67ff"}} className="nav-link" >Orientbell</a>
        </li>
        <li className="nav-item">
          <a href='Somany' style={{color:"#050f67ff"}} className="nav-link" >Somany</a>
        </li>
        <li className="nav-item">
          <a href='Jaquar' style={{color:"#050f67ff"}} className="nav-link" >Jaquar</a>
        </li>
        <li className="nav-item">
          <a href='Dulux' style={{color:"#050f67ff"}} className="nav-link" >Dulux</a>
        </li>
        <li className="nav-item">
          <a href='Coto' style={{color:"#050f67ff"}} className="nav-link" >Coto</a>
        </li>
        <li className="nav-item">
          <a href='Finolex' style={{color:"#050f67ff"}} className="nav-link" >Finolex</a>
        </li>
                <li className="nav-item">
          <a href='Watertec' className="nav-link" style={{color:"#050f67ff"}}>Water Tec</a>
        </li>
      
        <li className="nav-item">
          <a href='Contact' className="nav-link" style={{color:"#050f67ff"}}>Contact</a>
        </li>
      </ul>
      <form className="d-flex">
       <a style={{color:"white"}} className="topmarbelsowroomkarimpur  me-2" href="tel: +91 9932338173"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-plus" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
  <path fill-rule="evenodd" d="M12.5 1a.5.5 0 0 1 .5.5V3h1.5a.5.5 0 0 1 0 1H13v1.5a.5.5 0 0 1-1 0V4h-1.5a.5.5 0 0 1 0-1H12V1.5a.5.5 0 0 1 .5-.5z"/>
</svg> +91 9932 33 8173</a>
     
      </form>
    </div>
  </div>
</nav>
</div>
    </div>
  )
}

export default Navbar
